export const ty = 2025

